export enum ChatType {
  PLAYER = 'player',
  GAMBIT = 'gambit',
  SPARK = 'spark',
}
